import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from './ui/button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-6 text-center" data-testid="error-boundary">
          <AlertCircle className="h-12 w-12 text-red-400 mx-auto mb-3" />
          <h3 className="text-white font-semibold mb-2">Er is iets misgegaan</h3>
          <p className="text-slate-300 text-sm mb-4">
            {this.state.error?.message || 'Onbekende fout in dit onderdeel.'}
          </p>
          <Button
            variant="outline"
            className="border-red-500 text-red-400 hover:bg-red-500/20"
            onClick={this.reset}
          >
            Opnieuw proberen
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
